import React, { useEffect, useState } from 'react';
import { Menu, X, Hexagon } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Services',
    href: '#services'
  }, {
    name: 'Global Presence',
    href: '#about'
  }, {
    name: 'Why Us',
    href: '#why-us'
  }];
  return <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white/90 backdrop-blur-md shadow-sm py-4' : 'bg-transparent py-6'}`} data-id="element-148">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-149">
        <div className="flex justify-between items-center" data-id="element-150">
          <a href="#" className="flex items-center gap-2 group" data-id="element-151">
            <Hexagon className="w-8 h-8 text-accent group-hover:rotate-90 transition-transform duration-500" data-id="element-152" />
            <span className="text-xl font-bold text-primary tracking-tight" data-id="element-153">
              AlUniversalApps
            </span>
          </a>

          {/* Desktop Nav */}
          <div className="hidden md:flex items-center gap-8" data-id="element-154">
            {navLinks.map(link => <a key={link.name} href={link.href} className="text-sm font-medium text-slate-600 hover:text-accent transition-colors" data-id="element-155">
                {link.name}
              </a>)}
            <a href="#contact" className="px-5 py-2.5 bg-primary text-white text-sm font-medium rounded-full hover:bg-primary-light transition-colors shadow-sm hover:shadow-md" data-id="element-156">
              Get in Touch
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button className="md:hidden p-2 text-slate-600" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} data-id="element-157">
            {isMobileMenuOpen ? <X className="w-6 h-6" data-id="element-158" /> : <Menu className="w-6 h-6" data-id="element-159" />}
          </button>
        </div>
      </div>

      {/* Mobile Nav */}
      <AnimatePresence data-id="element-160">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="md:hidden bg-white border-t border-slate-100" data-id="element-161">
            <div className="px-4 pt-2 pb-6 space-y-1 shadow-lg" data-id="element-162">
              {navLinks.map(link => <a key={link.name} href={link.href} onClick={() => setIsMobileMenuOpen(false)} className="block px-3 py-4 text-base font-medium text-slate-700 hover:text-accent hover:bg-slate-50 rounded-md" data-id="element-163">
                  {link.name}
                </a>)}
              <a href="#contact" onClick={() => setIsMobileMenuOpen(false)} className="block w-full text-center mt-4 px-5 py-3 bg-primary text-white text-base font-medium rounded-md hover:bg-primary-light" data-id="element-164">
                Get in Touch
              </a>
            </div>
          </motion.div>}
      </AnimatePresence>
    </nav>;
}